import { useCallback, useMemo } from 'react';
import { Typography, Box, Paper } from '@mui/material';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Tabs } from '../../../components/shared';
import OpenTab from './OpenTab';
import FinalizedTab from './FinalizedTab';
import { routeConstants } from '../../../constants/routeConstants';

const MonthlyReconciliation = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const selectedTab = searchParams.get('selectedTab');
  const defaultTab = selectedTab === '1' || selectedTab === '2' ? selectedTab : '1';

  const handleTabChange = useCallback(
    (newValue) => {
      navigate(`/${routeConstants.MONTHLY_RECONCILIATION_ROUTE}?selectedTab=${newValue}`, { replace: true });
    },
    [navigate],
  );

  const tabs = useMemo(
    () => [
      {
        heading: 'Open',
        content: defaultTab === '1' ? <OpenTab /> : null,
      },
      {
        heading: 'Finalized',
        content: defaultTab === '2' ? <FinalizedTab /> : null,
      },
    ],
    [defaultTab],
  );

  return (
    <>
      <Typography variant="h1">Monthly Reconciliation</Typography>
      <Box mt={2} component={Paper}>
        <Tabs defaultTab={defaultTab} tabsData={tabs} onTabChange={handleTabChange} />
      </Box>
    </>
  );
};

export default MonthlyReconciliation;
